export const environment = {
	production: false,
	baseUrl: 'https://azureapi-test.arrowxl.co.uk/v1/',
	username: 'askaxltest',
	password: 'I6BN9Xdl7XIEBVhsw1GafKyP0Z1R3yzDdH4L9q'
};
